import React, { useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "tailwindcss/tailwind.css";
import useFetchData from "repo/get";
import usePutData from "repo/put";
import ReactHowler from "react-howler";
import positiveSound from "assets/positive.mp3";
import negativeSound from "assets/negative.mp3";
import CardStats from "../../logistica/base/CardBaseStatus";
import { ProgressSpinner } from 'primereact/progressspinner';


const CardDataTable = () => {
    const cargoSelect = localStorage.getItem("cargo") || "";


    const [sucesso, setSucesso] = useState(null);
    const [recebimentoSucesso, setRecebimentoSucesso] = useState(null);
    const [recebimentoError, setRecebimentoError] = useState(null);
    const [devolucaoSucesso, setdevolucaoSucesso] = useState(null);
    const [devolucaoError, setdevolucaoError] = useState(null);
    const [codigoRecebimento, setCodigoRecebimento] = useState("");
    const [codigoDevolucao, setCodigoDevolucao] = useState("");
    const [playSound, setPlaySound] = useState(null);
    const [isSubmittingRecebimento, setIsSubmittingRecebimento] = useState(false);
    const [isSubmittingDevolucao, setIsSubmittingDevolucao] = useState(false);
    const baseSelect = localStorage.getItem("baseSelected") || "";
    const { data: vencidoCount } = useFetchData(`api/devolucao/getCount/${baseSelect}`);
    const { putData } = usePutData();

    const handleAdicionarRomaneio = async ({ final, codigo, setSubmitting, setSuccess, setError }) => {
        if (!codigo) {
            setError("Por favor, preencha o código do romaneio.");
            setPlaySound(negativeSound);
            return;
        }
        setCodigoRecebimento("");
        setCodigoDevolucao("");
        setRecebimentoSucesso("");
        setRecebimentoError("");
        setdevolucaoSucesso("");
        setdevolucaoError("");
        setSucesso("");
        setError("");


        setSubmitting(true);

        try {
            const response = await putData(`api/devolucao/update`, {
                codigo,
                inbase: true,
                devolvido: true,
                finalizado: final,
                coletado: true,
                base: localStorage.getItem("baseSelected"),
            });

            if (response && response.id) {
                setSuccess(`${codigo} foi ${final ? "recebido" : "devolvido"} com sucesso.`);
                setError("");
                setPlaySound(positiveSound);
            } else {
                const errorMessage = response?.message || "Devolução não encontrada.";
                setError(errorMessage);
                setSuccess("");
                setPlaySound(negativeSound);
            }
        } catch (err) {
            const errorMessage = err?.message || "Erro ao conectar com o servidor.";
            setError(errorMessage);
            setSuccess("");
            setPlaySound(negativeSound);
        } finally {
            setSubmitting(false);
        }
    };

    const handleKeyDown = (event, type) => {
        if (event.key === "Enter") {
            event.preventDefault();
            if (type === "recebimento" && !isSubmittingRecebimento) {
                handleAdicionarRomaneio({
                    final: true,
                    codigo: codigoRecebimento,
                    setSubmitting: setIsSubmittingRecebimento,
                    setSuccess: setRecebimentoSucesso,
                    setError: setRecebimentoError,
                });
            }
            if (type === "devolucao" && !isSubmittingDevolucao) {
                handleAdicionarRomaneio({
                    final: false,
                    codigo: codigoDevolucao,
                    setSubmitting: setIsSubmittingDevolucao,
                    setSuccess: setdevolucaoSucesso,
                    setError: setdevolucaoError,
                });
            }
        }
    };

    return (
        <div className=" table-header w-full">
            <ul className="md:flex-col md:min-w-full flex flex-col list-none md:mb-4">
                <div className="flex flex-wrap">
                    <div
                        className="w-full lg:w-4/12 xl:w-4/12 px-2 justify-between text-left"

                    >
                        <CardStats
                            statSubtitle="Pacotes em tratativa em base"
                            colorSelect={"bg-orange-500"}
                            iconSelect={"fas fa-box-open"}
                            statTitle={vencidoCount?.inbase ?? 0}
                        />
                    </div>


                    <div
                        className="w-full lg:w-4/12 xl:w-4/12 px-2 justify-between text-left"

                    >
                        <CardStats
                            statSubtitle="Pacotes de tratativa em transito"
                            colorSelect={"bg-blue-500"}
                            iconSelect={"fas fa-truck"}
                            statTitle={vencidoCount?.devolvidos ?? 0}
                        />
                    </div>
                    <div
                        className="w-full lg:w-4/12 xl:w-4/12 px-2 justify-between text-left"

                    >
                        <CardStats
                            statSubtitle="Pacotes de tratativa finalizados"
                            colorSelect={"bg-emerald-500"}
                            iconSelect={"fas fa-check"}
                            statTitle={vencidoCount?.finalizados ?? 0}
                        />
                    </div>

                </div>
            </ul>
            <div className="flex flex-col md:flex-row  items-center justify-center gap-4 w-full">
                {/* Bloco de Devolução */}
                <div className="relative flex m-4 flex-col items-center w-1/2 shadow-lg rounded-lg bg-white p-6">
                    {isSubmittingDevolucao && (
                        <div className="absolute inset-0 z-10 flex items-center justify-center bg-white bg-opacity-50 rounded-lg">
                            <ProgressSpinner
                                style={{ width: '12rem', height: '12rem' }}
                                strokeWidth="8"
                                fill="var(--surface-ground)"
                                animationDuration=".5s"
                            />
                        </div>
                    )}
                    <h1 className="text-2xl font-bold p-component mb-4">RECEBIMENTO</h1>
                    <span className="text-sm font-bold p-component mb-2">
                        Insira o código para registrar recebimento pacotes de devolucão em base
                    </span>
                    <div className="mb-4 m-4">
                        <i className="pi pi-window-minimize" style={{ fontSize: "15rem" }}></i>
                    </div>
                    {cargoSelect !== "ENTREGADOR" && (
                        <input
                            type="text"
                            placeholder="Adicionar romaneio ..."
                            value={codigoDevolucao}
                            onChange={(e) => setCodigoDevolucao(e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e, "devolucao")}
                            className="p-inputtext p-component rounded-md shadow px-4 py-2 border border-black w-full"
                        />
                    )}
                    {devolucaoError && <p className="m-4 text-red-500">{devolucaoError}</p>}
                    {devolucaoSucesso && <p className="m-4 text-emerald-500">{devolucaoSucesso}</p>}
                </div>
                {/* Bloco de Recebimento */}
                <div className="relative flex m-4 flex-col items-center w-1/2 shadow-lg rounded-lg bg-white p-6">
                {isSubmittingRecebimento && (
                        <div className="absolute inset-0 z-10 flex items-center justify-center bg-white bg-opacity-50 rounded-lg">
                            <ProgressSpinner
                                style={{ width: '12rem', height: '12rem' }}
                                strokeWidth="8"
                                fill="var(--surface-ground)"
                                animationDuration=".5s"
                            />
                        </div>
                    )}
                    <h1 className="text-2xl font-bold p-component mb-4">DEVOLUÇÃO</h1>
                    <span className="text-sm font-bold p-component mb-2">
                        Insira o código para registrar a devolução ao remetente de origem.
                    </span>
                    <div className="mb-4 m-4">
                        <i className="pi pi-window-maximize " style={{ fontSize: "15rem" }}></i>
                    </div>
                    {cargoSelect !== "ENTREGADOR" && (
                        <input
                            type="text"
                            placeholder="Adicionar romaneio ..."
                            value={codigoRecebimento}
                            onChange={(e) => setCodigoRecebimento(e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e, "recebimento")}
                            className="p-inputtext p-component rounded-md shadow px-4 py-2 border border-black w-full"
                        />
                    )}
                    {recebimentoError && <p className="m-4 text-red-500">{recebimentoError}</p>}
                    {recebimentoSucesso && <p className="m-4 text-emerald-500">{recebimentoSucesso}</p>}
                </div>


            </div>

            {/* Mensagens de erro ou som */}
            <div className="w-full mt-4">
                {playSound && <ReactHowler src={playSound} playing={true} onEnd={() => setPlaySound(null)} />}
            </div>
        </div>
    );
};

export default CardDataTable;
